<template>
  <div class="oeamtc-position__sticky" style="top: 7rem;">
    <nav class="triplog-menu">
      <input type="checkbox" class="triplog-menu-open" name="triplog-menu-open" id="triplog-menu-open">
      <label class="triplog-menu-open-button" for="triplog-menu-open" title="Neuen Eintrag hinzufügen">
        <icon-trip-add-plus />
      </label>

      <div class="triplog-menu-item">
        <a @click="$emit('addTrip')" class="triplog-menu-item__link" title="Neue Fahrt">
          <icon-trip-add-newtrip />
        </a>
      </div>
      <div class="triplog-menu-item">
        <a @click="$emit('addFuelStop')" class="triplog-menu-item__link" title="Tankstopp">
          <icon-trip-add-newfuel />
        </a>
      </div>
<!--      <div class="triplog-menu-item"> todo: implement -->
<!--        <a @click="$emit('addService')" class="triplog-menu-item__link" title="Service">-->
<!--          <icon-trip-add-newservice />-->
<!--        </a>-->
<!--      </div>-->
    </nav>
  </div>
</template>

<script>
import { Component } from 'vue-property-decorator';
import IconTripAddPlus from '@components/icons/trip-add-button/icon-trip-add-plus.svg'
import IconTripAddNewtrip from '@components/icons/trip-add-button/icon-trip-add-newtrip.svg'
import IconTripAddNewfuel from '@components/icons/trip-add-button/icon-trip-add-newfuel.svg'
import IconTripAddNewservice from '@components/icons/trip-add-button/icon-trip-add-newservice.svg'
import Vue from 'vue';

@Component({
  name: 'TripAddButton',
  components: {
    IconTripAddPlus,
    IconTripAddNewtrip,
    IconTripAddNewfuel,
    IconTripAddNewservice
  },
})
export default class TripAddButton extends Vue {
}
</script>
